import React from 'react';
import { useOffline } from '../../components/App/AppOfflineContext';
import { useRouterContext } from '../../components/App/AppRouter';
import BusinessFunctionBadge from '../../components/BusinessFunctionBadge';
import type { ControlledDocumentSummaryModel } from '../../defs/defs';
import { EqxLink } from '@equinoxx/react';
import EqxListGroup, { EqxListGroupItem } from './EqxListGroup/EqxListGroup';

interface ControlledDocumentListProps {
    documents: ControlledDocumentSummaryModel[];
    isChild?: boolean;
}

const ControlledDocumentList: React.FC<ControlledDocumentListProps> = ({ documents, isChild }) => {
    const router = useRouterContext();
    const { isOffline, isFileCached } = useOffline();
    return (
        <EqxListGroup isChild={isChild}>
            {documents.map((doc) => (
                <EqxListGroupItem key={doc.id}>
                    <div className="clickable d-flex" onClick={() => router.navigate(`/controlled-documents/${doc.id}`)}>
                        <div className="m-1 me-3">{doc.businessFunction && <BusinessFunctionBadge businessFunction={doc.businessFunction} />}</div>
                        <div className="flex-grow-1">
                            <h6 className="mb-0"><EqxLink to={`/controlled-documents/${doc.id}`} className={isOffline && !isFileCached(`/controlled-documents/${doc.id}`) ? 'unavailable' : ''}>{doc.title}</EqxLink></h6>
                            <div className="small text-muted">{doc.reference}</div>
                        </div>
                        <div className="ms-3"><span className="badge bg-secondary">{doc.type?.name}</span></div>
                    </div>
                </EqxListGroupItem>
            ))}
        </EqxListGroup>
    );
};

export default ControlledDocumentList; 